package one.healthium.profile.ui.profile

import one.healthium.base.utils.BodyParamsUtils
import one.healthium.domain.user.UserModel
import one.healthium.profile.ui.models.CaloriesHistoryUiModel
import one.healthium.profile.ui.weight.WeightHistoryUiModel
import one.healthium.profile.ui.weight.formatRelative

internal data class ProfileUiModel(
    val isMetric: Boolean,
    val name: String,
    val initialWeight: Float,
    val currentWeight: Float,
    val targetWeight: Float,
    val currentBmi: Int,
    val targetBmi: Int,
    val weightHistory: List<WeightHistoryUiModel>,
    val caloriesHistory: List<CaloriesHistoryUiModel>,
    val visitsInRow: Int,
) {
    private val targetWeightLoss = initialWeight - targetWeight
    private val currentWeightLoss = initialWeight - currentWeight

    val weightLossLeft: Float = targetWeightLoss - currentWeightLoss
    val weightLossProgress: Float = currentWeightLoss / targetWeightLoss

    companion object {
        fun fromModel(
            isMetric: Boolean,
            user: UserModel,
            visitsInRow: Int,
        ) = ProfileUiModel(
            isMetric = isMetric,
            name = user.profile.name ?: "",
            initialWeight = user.profile.weight ?: 0f,
            currentWeight = user.currentWeight ?: 0f,
            targetWeight = user.profile.targetWeight ?: 0f,
            currentBmi = BodyParamsUtils.bmi(user.profile.weight, user.profile.height) ?: 0,
            targetBmi = BodyParamsUtils.bmi(user.profile.targetWeight, user.profile.height) ?: 0,
            weightHistory = user.weightLogs.map {
                WeightHistoryUiModel.fromModel(it)
            },
            caloriesHistory = user.foodLogs
                .filter { it.totalCalories > 0f }
                .map {
                    CaloriesHistoryUiModel(
                        value = it.totalCalories,
                        date = it.date.formatRelative(),
                    )
                },
            visitsInRow = visitsInRow,
        )
    }
}
